<template>
  <div
    v-if="pageName !== 'Complete'"
    style="margin-top:24px;width:100%;"
    layout="center-justify"
    self="size-x1"
  >
    <div self="size-x1" />
    <div self="right">
      <Button
        v-if="pageName !== 'Home'"
        type="default"
        @click="prevClicked"
      >
        {{ prevButton.label }}
      </Button>
    </div>
    <div style="margin-left: 6px;">
      <Button
        :loading="isSaving"
        :type="nextButton.type"
        @click="nextClicked"
      >
        {{ nextButton.label }}
      </Button>
    </div>
  </div>
</template>
<script>
import {
  mapState
} from 'vuex'
export default {
  props: {
    pageName: {
      type: String,
      default: ''
    },
    isSaving: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      inquiry: state => state.store.inquiry,
      pageIndex: state => state.store.pageIndex,
      numberOfPages: state => state.store.numberOfPages,
      journeyIsValid: state => state.store.journeyIsValid,
      contactIsValid: state => state.store.contactIsValid
    }),
    nextButton () {
      let label = null
      if (this.pageName !== 'Message' && this.pageName !== 'Summary') {
        label = 'weiter'
      } else {
        label = (this.inquiry.is_late_exchange) ? 'jetzt-weitere-angebote-anfordern' : 'jetzt-ein-unverbindliches-angebot-anfordern'
      }
      return {
        label: this.$t('static_translation.' + label),
        type: (this.pageIndex !== this.numberOfPages) ? 'primary' : 'success'
      }
    },
    prevButton () {
      const label = (this.pageName === 'Summary') ? 'zuruck-und-daten-andern' : 'zuruck'
      return {
        label: this.$t('static_translation.' + label),
        disabled: (this.pageIndex === 0)
      }
    },
    nextButtonDisabled () {
      const gdprPage = this.numberOfPages - 1
      if (!this.inquiry.is_late_exchange && this.pageIndex === gdprPage) {
        return (this.inquiry.GDPR !== true)
      }
      if (this.inquiry.is_late_exchange && this.pageIndex === this.numberOfPages) {
        return (this.inquiry.GDPR !== true)
      }
    }
  },
  methods: {
    prevClicked () {
      this.$emit('on-prev-page')
    },
    nextClicked () {
      this.$emit('on-next-page')
    }
  }
}
</script>
